export default "__VITE_ASSET__5UAsRLfa__"